// extracted by mini-css-extract-plugin
module.exports = {"ButtonArea":"SubtypeList_ButtonArea__SH9_G","TodoTemplateCol":"SubtypeList_TodoTemplateCol__EaOZx","ButtonCol":"SubtypeList_ButtonCol__7Ify7"};